import { CommonModule, NgOptimizedImage } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router'

import CoreModule from '../core/core.module'
import SharedModule from '../shared/shared.module'
import ConfirmationCarouselSlideDirective from './confirmation-carousel-slide/confirmation-carousel-slide.directive'
import ConfirmationAdditionalServicesComponent from './confirmation-additional-services/confirmation-additional-services.component'
import ConfirmationCarComponent from './confirmation-car/confirmation-car.component'
import ConfirmationCarouselComponent from './confirmation-carousel/confirmation-carousel.component'
import ConfirmationCreditCardComponent from './confirmation-credit-card/confirmation-credit-card.component'
import ConfirmationCustomerDetailsComponent from './confirmation-customer-details/confirmation-customer-details.component'
import ConfirmationEltonModalComponent from './confirmation-elton-modal/confirmation-elton-modal.component'
import ConfirmationOfferCardComponent from './confirmation-offer-card/confirmation-offer-card.component'
import ConfirmationComponent from './confirmation.component'

@NgModule({
  imports: [CommonModule, CoreModule, SharedModule, RouterModule, NgOptimizedImage, MatCardModule],
  declarations: [
    ConfirmationComponent,
    ConfirmationCarComponent,
    ConfirmationAdditionalServicesComponent,
    ConfirmationCustomerDetailsComponent,
    ConfirmationCreditCardComponent,
    ConfirmationEltonModalComponent,
    ConfirmationCarouselComponent,
    ConfirmationOfferCardComponent,
    ConfirmationCarouselSlideDirective,
  ],
  exports: [ConfirmationComponent],
})
export default class ConfirmationModule {}
